// Keeps the last few errors seen in this tab (JavaScript errors and failed
// API calls) so a bug report can include them. Paths only — no query strings,
// request bodies or response data.

const MAX = 10;
const recent = [];

const push = (msg) => {
    const line = `${new Date().toISOString().slice(11, 19)} ${String(msg).slice(0, 280)}`;
    recent.push(line);
    if (recent.length > MAX) recent.shift();
};

export const recentErrors = () => [...recent];

/** Called by the API client for 5xx responses and network failures. */
export const recordApiError = (method, url, status) => {
    const path = String(url || '').split(/[?#]/)[0];
    push(`${(method || 'GET').toUpperCase()} ${path} → ${status || 'network error'}`);
};

let installed = false;
export const installErrorCollector = () => {
    if (installed || typeof window === 'undefined') return;
    installed = true;
    window.addEventListener('error', (e) => push(`${e.message || 'Error'}${e.filename ? ` (${e.filename.split('/').pop()}:${e.lineno})` : ''}`));
    window.addEventListener('unhandledrejection', (e) => push(`Unhandled: ${e.reason?.message || e.reason || 'rejection'}`));
};

/** Event other components dispatch to open the report dialog. */
export const OPEN_BUG_REPORT = 'open-bug-report';
export const openBugReport = (type = 'BUG', prefill = {}) => window.dispatchEvent(new CustomEvent(OPEN_BUG_REPORT, { detail: { type, ...prefill } }));
